/*
 * @Author: Dom
 * @Date: 2022-07-20 17:14:00
 * @LastEditTime: 2022-07-20 17:47:30
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\store\currency.ts
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request'
import { getCurrencyType } from '@/services/currency';
import {CurrencyResType} from '@/services/data.d'

export interface StateType {
    errorMsg?: string;
    currtypelist: CurrencyResType;
}

export interface ModuleType extends StoreModuleType<StateType>{
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getCurreny: Mutation<StateType>;
    },
    actions: {
        getCurrencyTypeFn: Action<StateType,StateType>
    }
}

interface ListType {
    id: string;
    name:string;
    countryCode:string;
}

const initState: StateType = {
    errorMsg: undefined,
    currtypelist: {
        currlist: []
    }
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'currency',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        getCurreny(state,payload){
            state.currtypelist.currlist = payload
        }
    },
    actions: {
        async getCurrencyTypeFn({ commit }){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getCurrencyType({})
                const {body} = req
                console.log('curr-body', body);
                let list:any[] = []
                body?.forEach((i: any) =>{
                    list.push({
                        id:i.id,
                        name:i.currencyCode,
                        code:i.currencyCode
                    })
                })
                commit('getCurreny',list)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }

            commit('changeErrorMsg',msg);

            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        }
    }
}

export default StoreModel
